// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__oqijR","meals-appear":"AvailableMeals_meals-appear__ozXMw"};